import { prefix } from "../../design-tokens/meta";

export const componentName = "SideNavItem";

export const styleSelected = `${prefix}side-nav__item--selected`;

export const views = {
    selected: {
        classList: [styleSelected],
    },
    default: {
        classList: [`!${styleSelected}`],
    },
};

export const defaultProps = {
    selected: false,
};
